import {$} from './all'

export const trapFocus = (el, ev) => {
    const isTab = ev.key === 'Tab' || ev.keyCode === 9
    if (!isTab) return

    const elems = $(':focusable', el)
    const first = elems.first()[0]
    const last = elems.last()[0]

    if (first === last) {
        ev.preventDefault()
        return
    }

    if (ev.target === first && ev.shiftKey) {
        last.focus()
        ev.preventDefault()
        return
    }

    if (ev.target === last && !ev.shiftKey) {
        first.focus()
        ev.preventDefault()
        return
    }
}


// WEBPACK FOOTER //
// ./src/twd/trap-focus.js